/* eslint-disable react/prop-types */
/* eslint-disable max-lines-per-function */
import { Button, Col, Row } from 'antd';
import React from 'react';
import { AdLink } from '../AdLink';
import { AdStatus } from '../../../models';
import { getIconUrl } from '../../../services/asset';
import styles from './AdActions.scss';

const AdActions = ({ ad, adActions, onViewClick, className, target }) => (
  <div className={`${styles.actions} ${className}`}>
    <Row className={styles.topActions}>
      <Col xs={16} className={styles.leftActions}>
        <span role="presentation" onClick={adActions.onEdit}>
          {"Uredi"}
        </span>
        <span className={styles.veticalLine} />
        <AdLink ad={ad} onClick={onViewClick} className="" target={target}>{"Pogledaj"}</AdLink>

      </Col>
      <Col xs={8} className={styles.rightActions}>
        <img alt={"Obriši"} src={getIconUrl('garbage.svg')} />
        <span role="presentation" onClick={adActions.onDelete}>
          {"Obriši"}
        </span>
      </Col>
    </Row>
    <div className={styles.bottomActions}>
      {ad.status === AdStatus.active && (
        <Button
          className={`${styles.adActionButton} ${styles.pausedButton}`}
          onClick={adActions.onPaused}
        >
          {"Pauziraj"}
        </Button>
      )}
      {(ad.status === AdStatus.paused || ad.status === AdStatus.sold) && (
        <Button
          className={`${styles.adActionButton} ${styles.activeButton
            } ${ad.status === AdStatus.sold && styles.fullWidth}`}
          onClick={adActions.onActive}
        >
          {ad.status === AdStatus.sold
            ? "Reaktiviraj"
            : "Aktiviraj"}
        </Button>
      )}
      {ad.status !== AdStatus.sold && (
        <Button
          className={`${styles.adActionButton} ${styles.soldButton}`}
          onClick={adActions.onSold}
        >
          {"Prodano"}
        </Button>
      )}
    </div>
  </div>
);

export default AdActions;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdActions/AdActions.tsx